export default {
  route: {
    template: 'Feedback abgeben - {n}',
    fallback: 'Feedback abgeben',
    //dynamic use
    aboutVisit: 'Über den Besuch',
    checkout: 'Zahlung',
    digitalReceipt: 'Digitale Quittung',
    findVenue: 'Ort finden',
    getStarted: 'Loslegen',
    guestReceiptPinEntry: 'PIN-Eingabe für Gastquittung',
    guestTableNumberEntry: 'Tischnummer Eingabe für Gast',
    index: '',
    listNearbyLocations: 'Liste der nahegelegenen Standorte',
    locationCheckIn: 'Standort Check-In',
    manageTeam: 'Team verwalten',
    questions: 'Fragen',
    register: 'Gerät registrieren',
    recommend: 'Empfehlen',
    share: 'Teilen',
    staff: 'Teammitglied',
    survey: 'Gastumfrage',
    tabletCheckIn: 'Tablet Check-In',
    thankYou: 'Danke',
    teamMemberReceiptPinEntry: 'PIN-Eingabe für Teammitgliedquittung',
    teamMemberTableNumberEntry: 'Tischnummer Eingabe für Teammitglied',
    upload: 'Hochladen',
    error404: '404'
  }
};